export function generateDescription(who, topics, languagePreferred) {
    return `I am a ${who}, I usually post about ${topics}, I write my content in ${languagePreferred}, so reply to me in ${languagePreferred}`;
}